import { useNode } from "@craftjs/core";
import React, { useState } from "react";
import { isUpdatedFromDefault } from "../../utils";

import {
  CenterAlignActiveIcon,
  CenterAlignIcon,
  JustifyActiveIcon,
  JustifyIcon,
  LeftALignActiveIcon,
  LeftALignIcon,
  RightAlignActiveIcon,
  RightAlignIcon,
  PencilActiveIcon,
  SettingsIcon,
  PaintIcon,
} from "../../../assets/ui-icons";
import { IconPack } from "../../../assets/icon-pack";

import {
  ColorInput,
  OptionsInput,
  Panel,
  RangeInput,
  SpacerInput,
  PaddingInput,
  MarginInput,
  ToggleInput,
  Tabs,
} from "./../../ui-kit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowRestore } from "@fortawesome/free-solid-svg-icons";
import RightBar from "../../ui-kit/rightbar";
import { INPUT_LIMITS } from "../../input-limits";

export const CMSTabSettings = () => {
  const {
    actions: { setProp },
    props,
    id,
  } = useNode((node) => ({
    text: node.data.props.text,
    props: node.data.props,
  }));

  const {
    minHeight,
    maxWidth,
    showTabSubtitle,
    align,
    tabsGap,
    tabContentGap,
    typoSize = 16,
    titleTextColor,
    titleBackgroundColor,
    titlePadding = { top: "10px", botton: "20px", left: "10px", right: "20px" },
    titleMargin,
    contentBackgroundColor,
    contentPadding,
    contentMargin,
    linkColor,
  } = props;

  const General = () => {
    return (
      <>
        <SpacerInput>
          <RangeInput
            label="Min Height"
            min={INPUT_LIMITS["cms-width-height"].min}
            max={INPUT_LIMITS["cms-width-height"].max}
            step={INPUT_LIMITS["cms-width-height"].step}
            value={minHeight}
            onChange={(val) => {
              setProp((props) => {
                props.minHeight = val + "px";
                return props;
              });
            }}
          />

          <RangeInput
            label="Max Width"
            min={INPUT_LIMITS["cms-width-height"].min}
            max={INPUT_LIMITS["cms-width-height"].max}
            step={INPUT_LIMITS["cms-width-height"].step}
            value={maxWidth}
            onChange={(val) => {
              setProp((props) => {
                props.maxWidth = val + "%";
                return props;
              });
            }}
          />
          <ToggleInput
            label="Show Tab Subtitle"
            value={showTabSubtitle}
            onChange={(val) => {
              setProp((props) => {
                props.showTabSubtitle = val;
              });
            }}
          />

          <OptionsInput
            label={"Alignment"}
            value={align}
            onChange={(val) => {
              setProp((props) => {
                props.align = val;
              });
            }}
            options={[
              {
                label: "Justify",
                value: "space-between",
                icon: <JustifyIcon width={"20px"} />,
                active: <JustifyActiveIcon width={"20px"} />,
              },
              {
                label: "Left",
                value: "left",
                icon: <LeftALignIcon width={"20px"} />,
                active: <LeftALignActiveIcon width={"20px"} />,
              },
              {
                label: "Center",
                value: "center",
                icon: <CenterAlignIcon width={"20px"} />,
                active: <CenterAlignActiveIcon width={"20px"} />,
              },
              {
                label: "Right",
                value: "right",
                icon: <RightAlignIcon width={"20px"} />,
                active: <RightAlignActiveIcon width={"20px"} />,
              },
            ]}
          />
        </SpacerInput>
      </>
    );
  };

  const Styles = () => {
    return (
      <>
        <div className="w-full rounded-[21px] py-2 bg-white flex flex-col">
          <Panel label={"Container Gap"} isOpen={true}>
            <SpacerInput>
              <RangeInput
                label="Tabs Gap"
                min={INPUT_LIMITS["cms-gap"].min}
                max={INPUT_LIMITS["cms-gap"].max}
                step={INPUT_LIMITS["cms-gap"].step}
                value={tabsGap}
                onChange={(val) => {
                  setProp((props) => {
                    props.tabsGap = val + "px";
                    return props;
                  });
                }}
              />
              <RangeInput
                label="Tabs Content Gap"
                min={INPUT_LIMITS["cms-gap"].min}
                max={INPUT_LIMITS["cms-gap"].max}
                step={INPUT_LIMITS["cms-gap"].step}
                value={tabContentGap}
                onChange={(val) => {
                  setProp((props) => {
                    props.tabContentGap = val + "px";
                    return props;
                  });
                }}
              />
            </SpacerInput>
          </Panel>
        </div>
        <div className="bg-white mt-4 py-2 rounded-[21px] ">
          <Panel label={"Title"} isOpen={false}>
            <SpacerInput>
              <RangeInput
                resetValue={undefined}
                label="Title Size"
                value={typoSize}
                min={INPUT_LIMITS["cms-font-size"].min}
                max={INPUT_LIMITS["cms-font-size"].max}
                step={INPUT_LIMITS["cms-font-size"].step}
                onChange={(val) => {
                  setProp((props) => {
                    props.typoSize = val + "px";
                    return props;
                  });
                }}
              />
              <ColorInput
                value={titleTextColor}
                onChange={(val) => {
                  setProp((props) => {
                    props.titleTextColor = val;
                  });
                }}
                label={"Text"}
                useTextColorPalette={true}
              />
              <ColorInput
                value={titleBackgroundColor}
                onChange={(val) => {
                  setProp((props) => {
                    props.titleBackgroundColor = val;
                  });
                }}
                label={"Background"}
              />
              <ColorInput
                useTextColorPalette={true}
                supportSelection={true}
                value={linkColor}
                onChange={(val) => {
                  setProp((props) => {
                    props.linkColor = val;
                  });
                }}
                label={"Link"}
              />
            </SpacerInput>
          </Panel>
        </div>
        <div className="bg-white mt-4 py-2 rounded-[21px] ">
          <Panel label={"Content"} isOpen={false}>
            <SpacerInput>
              <ColorInput
                value={contentBackgroundColor}
                onChange={(val) => {
                  setProp((props) => {
                    props.contentBackgroundColor = val;
                  });
                }}
                label={"Background"}
              />
            </SpacerInput>
          </Panel>
        </div>
      </>
    );
  };
  const Advance = () => {
    return (
      <>
        <div className="w-full rounded-[21px] py-2 bg-white flex flex-col">
          <Panel label={"Title"} isOpen={false}>
            <SpacerInput>
              <PaddingInput
                value={titlePadding}
                onChange={(val) => {
                  setProp((props) => {
                    props.titlePadding = val;
                  });
                }}
              />
              <MarginInput
                value={titleMargin}
                onChange={(val) => {
                  setProp((props) => {
                    props.titleMargin = val;
                  });
                }}
              />
            </SpacerInput>
          </Panel>
        </div>
        <div className="bg-white mt-4 py-2 rounded-[21px] ">
          <Panel label={"Content"}>
            <SpacerInput>
              <PaddingInput
                value={contentPadding}
                onChange={(val) => {
                  setProp((props) => {
                    props.contentPadding = val;
                  });
                }}
              />
              <MarginInput
                value={contentMargin}
                onChange={(val) => {
                  setProp((props) => {
                    props.contentMargin = val;
                  });
                }}
              />
            </SpacerInput>
          </Panel>
        </div>
      </>
    );
  };

  const tabs = [
    {
      label: "General",
      key: "general",
      icon: IconPack.GeneralSettings,
      children: General(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Style",
      key: "style",
      icon: IconPack.Style,
      children: Styles(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Advanced",
      key: "advanced",
      icon: IconPack.Settings,
      children: Advance(),
      isUpdated: isUpdatedFromDefault([]),
    },
  ];

  return (
    <div className="h-full w-[330px] post-edit-right-sidebar cursor-default p-2 overflow-auto dashboard-ui-scrollbar ">
      <div className="w-full rounded-t-[21px] bg-white">
        <div className="p-5 flex justify-between">
          <RightBar
            title={"Tabs"}
            icon={
              <FontAwesomeIcon
                icon={faWindowRestore}
                size="2xl"
                color="#8402E9"
              />
            }
          />
        </div>

        <Tabs id={`block-cms-settings-tab-${id}`} items={tabs} />

        <div className="py-2 bg-ui-light-white"></div>
      </div>
    </div>
  );
};
